import '@/js/dist/www.iichi.com/common';

import Vue from 'vue';
import SortUi from '@/js/components/retail-store/sort.vue';

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    el: 'sort-ui',
    components: {
      SortUi,
    },
  });
});
